import { OpacityUpdater } from "./OpacityUpdater";
export async function loadOpacityUpdater(engine, refresh = true) {
    await engine.addParticleUpdater("opacity", (container) => new OpacityUpdater(container), refresh);
}
